import { tracking } from '@/tracking'

type ConventionTrackingPayload = {
  conventionSlug?: string
  conventionProductId: number
  conventionName?: string | null
  registrationOptionId?: number | null
  registrationOptionName?: string | null
  registrantsCount?: number | null
  acceptedTerms?: boolean
}

const buildConventionTrackingPayload = ({
  conventionSlug,
  conventionProductId,
  conventionName,
  registrationOptionId,
  registrationOptionName,
  registrantsCount,
  acceptedTerms,
}: ConventionTrackingPayload) => {
  return {
    conventionSlug: conventionSlug || undefined,
    conventionProductId,
    conventionName: conventionName || undefined,
    registrationOptionId: registrationOptionId ?? undefined,
    registrationOptionName: registrationOptionName || undefined,
    registrantsCount: registrantsCount ?? undefined,
    acceptedTerms: acceptedTerms ?? undefined,
  }
}

export const trackViewedConventionRegistrationStart = (
  payload: ConventionTrackingPayload
) => {
  tracking.track(
    'Viewed convention registration start page',
    buildConventionTrackingPayload(payload)
  )
}

export const trackSelectedConventionRegistrationTicketType = (
  payload: ConventionTrackingPayload
) => {
  tracking.track(
    'Selected convention registration ticket type',
    buildConventionTrackingPayload(payload)
  )
}

export const trackSubmittedConventionRegistrationDetails = (
  payload: ConventionTrackingPayload
) => {
  tracking.track(
    'Submitted convention registration details',
    buildConventionTrackingPayload(payload)
  )
}

export const trackViewedConventionWaitlistPage = (
  payload: ConventionTrackingPayload
) => {
  tracking.track(
    'Viewed convention wait list page',
    buildConventionTrackingPayload(payload)
  )
}

export const trackSignedUpForConventionWaitlist = (
  payload: ConventionTrackingPayload
) => {
  tracking.track(
    'Signed up for convention wait list',
    buildConventionTrackingPayload(payload)
  )
}
